import { render, staticRenderFns } from "./ImmobilizeReport.vue?vue&type=template&id=36f1a966&"
import script from "./ImmobilizeReport.vue?vue&type=script&lang=js&"
export * from "./ImmobilizeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports